import React, { useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import { AppBar, Toolbar } from "@material-ui/core";
import { GeneralTabs } from "./Tabs/GeneralTabs";
import { ModuleTabs } from "./Tabs/ModuleTabs";
import { ModuleList } from "./modules/ModuleList";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
/* import TemplateSettings from '../../templateSettings/TemplateSettings'; */
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import ReplayOutlinedIcon from "@material-ui/icons/ReplayOutlined";
import { ModuleSettings } from "../../components/ModuleSettings";
import SettingsList from "../../../cms/areas/template/components/SettingsList";
import { PositionAndSizeTools } from "../../components/PositionAndSizeTools";
import TemplateSelector from "../other/TemplateSelector";
import EventSelector from "../other/EventSelector";
import ViewCompactOutlinedIcon from "@material-ui/icons/ViewCompactOutlined";
import CalendarTodayOutlinedIcon from "@material-ui/icons/CalendarTodayOutlined";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import LayoutSelector from "../other/LayoutSelector";
const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

function EditorSidebar(props) {
  const [view, setView] = React.useState("");
  const classes = useStyles();
  const {
    selectedModule,
    onDeselect,
    deleted,
    deleteModule,
    onEdit,
    deleteLayoutModule,
    eventName,
    layoutName,
  } = props;
  const prevProps = usePrevious(props);
  useEffect(() => {
    if (selectedModule && !prevProps.selectedModule) setView("ContentSettings");
    if (!selectedModule && !view) setView("Modules");
    if (!view) setView("Modules");
  }, [selectedModule]);
  const renderView = (key) => {
    switch (key) {
      case "Modules":
        return <ModuleList {...props} tab={"Modules"} />;
      case "MyModules":
        return <ModuleList view={"MyModules"} {...props} tab={"MyModules"} />;
      case "ContentSettings":
        if (!selectedModule) return null;
        return (
          <ModuleSettings
            settings={selectedModule.settings}
            tab={key}
            module={selectedModule}
            type={selectedModule.moduleType}
            onChange={onEdit}
            {...props}
          >
            <PositionAndSizeTools {...props} />
          </ModuleSettings>
        );
      case "StyleSettings":
        if (!selectedModule) return null;
        return (
          <ModuleSettings
            settings={selectedModule.settings}
            tab={key}
            module={selectedModule}
            type={selectedModule.moduleType}
            onChange={onEdit}
          />
        );
      case "AdvancedSettings":
        return null;
      case "Template":
        return (
          <div>
            <TemplateSelector {...props} />
            <SettingsList />
          </div>
        );
      default:
        return null;
    }
  };
  const toggleView = (view) => {
    if (
      selectedModule &&
      (view == "Modules" || view == "MyModules" || view == "Template")
    ) {
      onDeselect();
    }
    setView(view);
  };

  return (
    <div className="sidebar-wrapper dark">
      <div className="sidebar-details">
        <EventSelector {...props} />
        <LayoutSelector {...props} />
      </div>
      <GeneralTabs toggle={toggleView} activeTab={view} slim={selectedModule} />
      {selectedModule ? (
        <ModuleTabs toggle={toggleView} activeTab={view} />
      ) : null}
      {renderView(view)}

      {selectedModule && selectedModule.meetingLayoutId ? (
        <div className="sidebar-footer">
          <Button
            onClick={() => deleteLayoutModule(selectedModule)}
            startIcon={
              deleted ? <ReplayOutlinedIcon /> : <DeleteOutlineOutlinedIcon />
            }
            className={"editor-full-btn remove"}
            style={{ backgroundColor: deleted ? "#535562" : undefined }}
          >
            {deleted ? (
              <SystemLabel name="Undo" />
            ) : (
              <SystemLabel name="RemoveFromLayout" />
            )}
          </Button>
        </div>
      ) : null}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    template: state.template.template,
    templates: state.template ? state.template.templates : undefined,
    templateIsSavable: state.template.isSavable,
  };
}
export default connect(mapStateToProps)(EditorSidebar);
